export default {
  title: 'Accumula punti e ottieni premi',
  header: {
    pickup: 'Ritiro in 5 minuti',
  },
  recommendations: {
    title: 'Consigliati',
  },
  discounts: {
    title: 'Sconti',
    data: [
      {
        title: '+125 punti extra',
        description: 'Valutaci su Google',
      },
      {
        title: '+{{amount}} sconto',
        description: '+{{amount}} sconto pagando con il codice {{code}}',
      },
    ],
    button: {
      add: '+ Aggiungi',
    },
  },
  rewards: {
    title: 'Premi e coupon',
    balance: 'Saldo',
    points: 'Punti',
  },
};
